if (!customElements.get('td-cart-note')) {
  customElements.define('td-cart-note', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.td-cart-note__input');
      this.status = this.querySelector('[data-note-status]');
      if (!this.input) return;

      // If the drawer re-rendered mid-type, restore the unsaved text.
      if (window.__tdPendingNote != null && !this.input.value) {
        this.input.value = window.__tdPendingNote;
      }

      this.controller = new AbortController();
      const { signal } = this.controller;
      this.timer = null;

      this.input.addEventListener('input', () => {
        window.__tdPendingNote = this.input.value;
        clearTimeout(this.timer);
        this.setStatus('Saving…', 'saving');
        this.timer = setTimeout(() => this.save(), 300);
      }, { signal });

      this.input.addEventListener('blur', () => {
        clearTimeout(this.timer);
        this.save();
      }, { signal });

      window.addEventListener('pagehide', () => {
        if (!this.input) return;
        const blob = new Blob([JSON.stringify({ note: this.input.value })], {
          type: 'application/json'
        });
        navigator.sendBeacon('/cart/update.js', blob);
      }, { signal });
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.controller) this.controller.abort();
    }

    setStatus(text, state) {
      if (!this.status) return;
      this.status.textContent = text;
      this.status.setAttribute('data-state', state || '');
    }

    save() {
      const url = (window.routes && window.routes.cart_update_url) || '/cart/update';
      fetch(`${url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: this.input.value })
      })
        .then((r) => { if (!r.ok) throw new Error(r.statusText); return r.json(); })
        .then(() => {
          window.__tdPendingNote = null;
          this.setStatus('Saved to your order', 'saved');
        })
        .catch(() => this.setStatus('Not saved — try again', 'error'));
    }
  });
}